// @flow
import React, { Component } from 'react'
import LineInput from './LineInput'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  position: relative;
`

const Counter: StyledComponent<Object, any, any> = styled.span`
  font-family: 'PT Sans Caption', sans-serif;
  font-size: 11px;
  color: #000;
  display: inline-block;
  position: absolute;
  right: 8px;
  bottom: 7px;
  ${({ warning }: Object) => (warning ? 'color: red' : '')};
`

type Props = {|
  value: string,
  maxLength: number,
  className?: string,
  placeholder?: string,
  multiline?: boolean,
  onChange: (string) => void
|}

type State = {|
  charsCount: number
|}

export default class LimitedInput extends Component<Props, State> {
  render() {
    const inputProps = {
      maxLength: this.props.maxLength,
      size: this.props.maxLength,
      placeholder: this.props.placeholder,
      className: this.props.className
    }

    return (
      <Wrapper>
        <LineInput
          value={this.props.value}
          inputProps={inputProps}
          extraStyles={{ paddingRight: '35px' }}
          multiline={this.props.multiline}
          onChange={(e) => this.changed(e)}
        />
        <Counter warning={this.charsRemainCount() < 10}>{this.charsRemainCount()}</Counter>
      </Wrapper>
    )
  }

  changed(value: string) {
    this.props.onChange(value)
  }

  charsRemainCount() {
    return this.props.maxLength - (this.props.value || '').length
  }
}
